<template>
	<div id="contentDiv" :style="contentCSS">
		<a-row :gutter="8" type="flex" align="top">
			<a-col :span="16" v-if="notWH">
				<a-card title="淅川西岛光电仪表科技有限公司欢迎您">
				      <p class="textDetail">
				      	我公司是专业从事光电直读式远传水、电、燃气三表以及远程集中自动抄表系统硬件和软件的技术研发、产品生产、销售、系统方案设计、施工、调试、运行和售后服务为一体的高科技企业。
				      	公司位于国家南水北调中线工程渠首所在地淅川--南水北调水源地丹江水库，淅川被列为国家十二五规划的生态建设示范区。为了"一库清水送北京"，国家关闭一切污染企业，大力支持和鼓励高科技产业的发展，西岛科技在政府和科研单位、大专院校的支持下成立了。公司占地80000平方米，投资5000万人民币。
				      </p>
				      <p class="textDetail">
						  拥有丰富实践经验、有着高度责任感和实干精神的技术研发、产品生产、现场施工技术等专业人员，已形成一支由教授、高级工程师、研究员、硕士等高级科技人才组成的具有专业特点，极强研发能力的强大团队。
						  公司对全国各地远传集中自动抄表系统使用过程中出现的问题进行分析、研究，将技术研发的方向定位在"光电直读"上。并在水、电、燃气表基表的基础上，研制生产了直读式水、电、燃气表远传集中自动抄表系统，与国内大专院校和著名光电专家长期合作。
						  我公司以"诚信服务客户，成就龙头企业"为目标，致力于为客户创建"不扰民、低成本、高收益、人性化的数字管理新环境"。形成了"6年保修 十年维修"的服务理念，拥有强大的技术支持和不断升级、完善的售后服务体系。
					  </p>
				</a-card>
			</a-col>
			<a-col :span="16" v-else>
				<a-card title="不在线集中器统计">
					<!-- <div id="barChart"></div> -->
					<vxe-table  align="center" :data="gprsLogList"   height="360"  ref="mTable" show-overflow="title" size="mini">
						<vxe-table-column type="seq" width="45"></vxe-table-column>
						<vxe-table-column title="所属小区" field="NeighborName"></vxe-table-column>
						<vxe-table-column title="集中器地址" field="GPRSAddr" ></vxe-table-column>
						<vxe-table-column title="安装地址" field="InstallAddr"></vxe-table-column>
						<vxe-table-column title="下线时间" field="createTime"></vxe-table-column>
					</vxe-table>	
				</a-card>
			</a-col>
			<a-col :span="8"  v-if="notWH">
				<a-card title="抄表率">
					<ve-gauge :data="chartData" height="352px"/>
				</a-card>
			</a-col>
			<a-col :span="8"  v-else>
				<a-card title="用量异常分类">
					<div id="pieChart"></div>
				</a-card>
			</a-col>
		</a-row>
		<div id="statisDiv">
			<a-row :gutter="[10,16]">
				<a-col :span="6">
					<a-card style="background-color: #5cadff;">
						<a-statistic  :value="statisObj.neighborCount" :precision="0" :value-style="{ fontSize: 'large',color:'white',fontWeight:'bold' }">
							<template #title>
								<span style="color:white">小区总数</span>
							</template>
							<template #prefix>
								<a-icon type="home"  :style="{ fontSize: '24px'}"/>
							</template>
						</a-statistic>
					</a-card>
				</a-col>
				<a-col :span="6">
					<a-card style="background-color: #A2F0FF;" @click="gotoNeighbor">
						<a>
							<a-statistic  :value="neighborListLastest.length" :precision="0" :value-style="{ fontSize: 'large',color:'white',fontWeight:'bold' }">
								<template #title>
									<span style="color:white">30天新增小区</span>
								</template>
								<template #prefix>
									<a-icon type="folder-add"  :style="{ fontSize: '24px'}"/>
								</template>
							</a-statistic>
						</a>
					</a-card>
				</a-col>
				<a-col :span="6">
					<a-card style="background-color: #ff9900;">
						<a-statistic :value="statisObj.gprsCount" :precision="0" :value-style="{ fontSize: 'large',color:'white',fontWeight:'bold' }">
							<template #title>
								<span style="color:white">集中器总数</span>
							</template>
							<template #prefix>
								<a-icon type="cluster"  :style="{ fontSize: '24px'}"/>
							</template>
						</a-statistic>
					</a-card>
				</a-col>
				<a-col :span="6">
					<a-card  style="background-color: #2db7f5;">
						<a-statistic  :value="statisObj.metersCount" :precision="0" :value-style="{ fontSize: 'large',color:'white',fontWeight:'bold' }">
							<template #title>
								<span style="color:white">水表总数</span>
							</template>
							<template #prefix>
								<a-icon type="dashboard"  :style="{ fontSize: '24px'}"/>
							</template>
						</a-statistic>
					</a-card>
				</a-col>
			</a-row>
			<a-row :gutter="[10,16]">
				<a-col :span="6">
					<a-card style="background-color:  #7AA6FF; ">
						<a-statistic  :value="statisObj.customerCount" :precision="0" :value-style="{ fontSize: 'large',color:'white',fontWeight:'bold' }">
							<template #title>
								<span style="color:white">用户总数</span>
							</template>
							<template #prefix>
								<a-icon type="user"  :style="{ fontSize: '24px'}"/>
							</template>
						</a-statistic>
					</a-card>
				</a-col>
				<a-col :span="6">
					<a-card style="background-color: #67C23A; ">
						<a-statistic   :value="statisObj.okMetersCount" :precision="0" :value-style="{ fontSize: 'large',color:'white',fontWeight:'bold' }">
							<template #title>
								<span style="color:white">抄表正常数</span>
							</template>
							<template #prefix>
								<a-icon type="check"  :style="{ fontSize: '24px'}"/>
							</template>
						</a-statistic>
					</a-card>
				</a-col>
				<a-col :span="6">
					<a-card style="background-color: #F56C6C;" @click="gotoFailMeter">
						<a>
							<a-statistic  :value="statisObj.wrongMetersCount" :precision="0" :value-style="{ fontSize: 'large',color:'white',fontWeight:'bold' }">
								<template #title>
									<span style="color:white">抄表故障数</span>
								</template>
								<template #prefix>
									<a-icon type="info-circle"  :style="{ fontSize: '24px'} "/>
								</template>
							</a-statistic>
						</a>
					</a-card>
				</a-col>
				<a-col :span="6">
					<a-card style="background-color: #A0CFFF">
						<a-statistic  :value="readMeterFailRate" :precision="2" :value-style="{ fontSize: 'large',color:'white',fontWeight:'bold' }" suffix="%">
							<template #title>
								<span style="color:white">抄表故障率</span>
							</template>
							<template #prefix>
								<a-icon type="file-done"  :style="{ fontSize: '24px'} "/>
							</template>
						</a-statistic>
					</a-card>
				</a-col>
			</a-row>
		</div>
		<div id="statisDetailDiv">
		</div>
		<a-modal :destroyOnClose="true"
		       :dialog-style="{ top: '60px',left:'640px' }" width="360px" 
		       v-model:visible="showAlarm4WH"
		       @ok="setModal1Visible(false)">
			   <div>
				   <a-row v-for="(item,index) in alarmDataList" style="margin-top: 0.3rem;">
						<a-col :span="12">
							{{getAlarmName(item.alarm_type)}}
						</a-col>
						<a-col :span="12">
							<div style="float: right;">
								<a-tag color="orange">
									{{item.tCount}}
								</a-tag>
							</div>
						</a-col>
				   </a-row>
			   </div>
				<template slot="title">
					<div style="display: flex; flex-direction: row; align-items: center;">
						<a-icon type="exclamation-circle" :style="{ fontSize: '20px', color: '#FBC14F' }"/>
						<label style="font-size: 1.125rem;margin-left: 0.5rem;margin-top: -0.1rem;">告警提示</label>
					</div>
				</template>
			   <template slot="footer">
					<a-button icon="profile"   @click="goAlarmPage">查看详情</a-button>
				</template>
		</a-modal>
	</div>
</template>

<script>
	import * as echarts from 'echarts';
	export default {
		data(){
			return{
				contentCSS:{
					//backgroundImage: "url(" + require('../assets/welcome.jpg') + ")",
				},
				neighborListLastest:[],
				statisObj:{},
				chartData: {
						columns: ["type", "value"],
						rows: [{ type: "抄表率",value:"0"}],
				},
				notWH:true,
				barChart:null,
				pieChart:null,
				showAlarm4WH:false,
				alarmDataList:[],
				gprsLogList:[],
			}
		},
		methods:{
			getAlarmName(alarmType){
				let result = '';
				let alarmTypeList = this.Config.getAlarmTypeList();
				for(var i =0 ;i<alarmTypeList.length;i++){
					let item = alarmTypeList[i];
					if(alarmType == item.value){
						result = item.name;
						break;
					}
				}
				return result;
			},
			goAlarmPage(){
				this.$emit('parentMethod',['meterAlarm']);
				this.showAlarm4WH = false;
			},
			queryAlarmData(){
				let url = this.Api.getLastUrl(this.Api.QUERY_METER_ALRAM_INFO_URL);
				this.Api.fetchPostWithForm(url).then((data)=>{
					let code = data.data.code;
					let result = data.data.result;
					let msg = data.data.message;
					if(code == this.Api.HTTP_OK_CODE){
						this.alarmDataList = result;
						if(this.alarmDataList.length>0){
							this.showAlarm4WH = true;
						}
					}else{
						this.$message.error(msg);
					}
				}).catch((error)=>{
					console.log(error);
				});
			},
			gotoDetail(){
				this.$emit('parentMethod',['over']);
			},
			initCharts(){
				// let a = window.document.getElementById("barChart");
				// this.barChart = echarts.init(a);
				
				let b = window.document.getElementById("pieChart");
				this.pieChart = echarts.init(b);
			},
			gotoNeighbor:function(){
				this.$emit('parentMethod',['neighbor']);
			},
			gotoFailMeter(){
				//暂时只开放威海地区
				if(this.notWH == false){
					this.$emit('parentMethod',['failMeter']);
				}
			},
			queryDataList:function(){
				let url = this.Api.getLastUrl(this.Api.MAIN_STATIS_URL);
				this.Api.fetchPostWithForm(url).then((data)=>{
					let code = data.data.code;
					let result = data.data.result;
					let msg = data.data.message;
					if(code == this.Api.HTTP_OK_CODE){
						this.statisObj = result;
						this.chartData.rows[0].value= this.readMeterRate;
					}else{
						this.$message.error(msg);
					}
				}).catch((error)=>{
					console.log(error);
				});
			},
			getLastestNeighbor:function(departmentId){
				let url = this.Api.getLastUrl(this.Api.NEIGHBOR_LASTEST_LIST_URL);
				let param = {departId:departmentId};
				this.Api.fetchPostWithForm(url,param).then((data)=>{
					let code = data.data.code;
					let result = data.data.result;
					let msg = data.data.message;
					if(code == this.Api.HTTP_OK_CODE){
						this.neighborListLastest = result;
					}else{
						this.$message.error(msg);
					}
				}).catch((error)=>{
					console.log(error);
				});
			},
			queryOverData(){
				let url = this.Api.getLastUrl(this.Api.QUERY_OVER_DATA_STATIS_URL);
				this.Api.fetchPostWithForm(url).then((data)=>{
					let code = data.data.code;
					let result = data.data.result;
					let msg = data.data.message;
					if(code == this.Api.HTTP_OK_CODE){
						this.drawBarResult(result);
					}else{
						this.$message.error(msg);
					}
				}).catch((error)=>{
					console.log(error);
				});
			},
			drawBarResult(data){
				this.gprsLogList = data.data4List;
				var colorList = ['#527BF6','#FFA854','#0DB8F5','#19be6b'];
				var pieData = data.data4Pie;
				var yyData = [];
				for(var i = 0;i<pieData.length;i++){
					let item = pieData[i];
					yyData.push(
						{value: item.totalCount, name:item.result_desc,itemStyle: {color: colorList[i]}}
					);
				}
				var option1 = {
					tooltip: {
						trigger: 'item',
					},
					legend: {
					    orient: 'vertical',
					    left: 'left',
						top: 'bottom',
					},
					series: [
						{
							name:'异常类型',
							data: yyData,
							type: 'pie',
							radius: '60%',
						}
				  ]
				};
				this.pieChart.setOption(option1);
			},
		},
		created() {
			this.getLastestNeighbor(this.Config.getUserLocal().departmentId);
			let wcId = this.Config.getUserLocal().wcId;
			if(wcId == 37){
				this.notWH = false;
				this.queryOverData();
			}else{
				this.notWH = true;
			}
			this.queryDataList();
		},
		mounted(){
			let wcId = this.Config.getUserLocal().wcId;
			if(wcId == 37){
				this.initCharts();
				this.queryAlarmData();
			}
		},
		computed:{
			readMeterFailRate:function(){
				let sum = this.statisObj.okMetersCount+ this.statisObj.wrongMetersCount;
				let rate = Number(this.statisObj.wrongMetersCount/sum)*100;
				return  rate.toFixed(2);
			},
			readMeterRate:function(){
				let sum = this.statisObj.okMetersCount+ this.statisObj.wrongMetersCount;
				let rate = Number(sum/this.statisObj.metersCount)*100;
				return  rate.toFixed(2);
			},
			
		},
	
		
	}
</script>

<style scoped="scoped">
	#contentDiv{
		padding: 1rem 5rem 0 5rem;
		width: 100%;
		height: calc(100vh - 8.125rem);
		overflow-y: auto;
		overflow-x:hidden;
		background: no-repeat center top;
		background-size: cover;
	}
	#statisDiv{
		margin-top: 1rem;
		padding: 0;
	}
	#statisDetailDiv{
		margin-top: 1rem;
		padding: 0;
	}
	.textDetail{
		line-height:2rem;
		font-size: 0.85rem;
	}
	#barChart{
		width: 100%;
		height: 360px;
	}
	#pieChart{
		width: 100%;
		height: 360px;
	}
</style>
